import {createUseStyles} from 'react-jss';
import {Theme} from '../themes/default';
import ncp_bg_form from '../../assets/images/ncp/2026/formular_1.png';
import patternAlb from '../../assets/images/patternAlb.jpg';

const useFormStyles = createUseStyles((theme: Theme) => {
    return {
        formWrapper: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: `${theme.spacing(8)} ${theme.spacing(3)}`,
            boxSizing: 'border-box',
            [theme.breakpoints.down('sm')]: {
                padding: `${theme.spacing(6)} ${theme.spacing(2)}`,
            }
        },
        boxTitle: {
            backgroundImage: `url(${ncp_bg_form})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            padding: theme.spacing(4),
            paddingBottom: theme.spacing(8),
            borderRadius: '5vh',
            width: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxSizing: 'border-box',
            [theme.breakpoints.down('sm')]: {
                padding: theme.spacing(3),
                paddingBottom: theme.spacing(6),
                borderRadius: '4vh',
                width: '100%',
            }
        },
        title: {
            fontFamily: theme.fonts.poplar,
            fontSize: '36px',
            fontWeight: "bold",
            color: '#000000',
            textAlign: 'center',
            [theme.breakpoints.down('sm')]: {
                fontSize: '24px',
                fontWeight: "normal",
                letterSpacing: '1px',
            }
        },
        paperForm: {
            borderRadius: '3vw',
            margin: '0 auto',
            marginTop: `-${theme.spacing(8)}`,
            padding: theme.spacing(6),
            backgroundImage: `url(${patternAlb})`,
            maxWidth: '600px',
            width: '100%',
            boxSizing: 'border-box',
            [theme.breakpoints.down('sm')]: {
                marginTop: `-${theme.spacing(6)}`,
                padding: theme.spacing(3),
            },
        },
        formInput:{
            marginTop: theme.spacing(3),
            '& .MuiInputBase-root': {
                fontFamily: theme.fonts.apex,
                fontSize: '18px',
                lineHeight: 1,
                fontWeight: 'bold',
                borderRadius: theme.spacing(2),
                letterSpacing: '1px',
                backgroundColor: theme.palette.background.default,
                color: theme.palette.primary.main,
                [theme.breakpoints.down('sm')]: {
                    fontSize: '16px',
                    fontWeight: 'normal',
                },
            },
            '& .MuiInputLabel-root': {
                fontFamily: theme.fonts.apex,
                fontWeight: 'bold',
                fontSize: '18px',
                letterSpacing: '1px',
                [theme.breakpoints.down('sm')]: {
                    fontSize: '16px',
                    fontWeight: 'normal',
                },
            },
            '& .MuiInputLabel-shrink': {
                fontSize: '18px',
                letterSpacing: '1px',
                color: theme.palette.primary.main,
                [theme.breakpoints.down('sm')]: {
                    fontSize: '16px',
                    fontWeight: 'normal',
                },
            }
        },
        formControlCheckbox:{
            fontFamily: theme.fonts.apex,
            fontWeight: 'bold',
            fontSize: '18px',
            letterSpacing: '1px',
            marginTop: theme.spacing(3),
            display: 'flex',
            justifyContent: 'space-between',
            '& p': {
                textAlign: "left",
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '16px',
                fontWeight: 'normal',
            },
        },
        formControlCheckboxLabel:{
            fontFamily: theme.fonts.apex,
            fontWeight: 'bold',
            fontSize: '18px',
            letterSpacing: '1px',
            color: theme.palette.primary.main,
            '& a':{
                color: 'inherit',
                textDecoration: 'underline',
                textTransform: 'uppercase',
                fontStyle: 'italic',
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '14px',
                fontWeight: 'normal',
                lineHeight: 1,
            },
        },
        submitButtonContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginTop: theme.spacing(3),
        },
        submitButton:{
            fontFamily: theme.fonts.apex,
            fontSize: '20px',
            fontWeight: 'bold',
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.secondary.main,
            padding: `${theme.spacing(2)} ${theme.spacing(5)}`,
            '&:hover': {
                color: theme.palette.primary.main,
                backgroundColor: theme.palette.secondary.main,
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '18px',
                fontWeight: 'bold',
                padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
            },
            [theme.breakpoints.only('xs')]: {
                fontSize: '14px',
                padding: `${theme.spacing(2)} ${theme.spacing(2)}`,
            }
        },
        bottomText: {
            width: '50%',
            maxWidth: '600px',
            borderTop: '3px dotted #FFFFFF',
            paddingTop: theme.spacing(4),
            marginTop: theme.spacing(6),
            boxSizing: 'border-box',
            [theme.breakpoints.down('sm')]: {
                paddingTop: theme.spacing(3),
                marginTop: theme.spacing(4),
                width: '100%',
            }
        },
        bottomTextContent: {
            fontFamily: theme.fonts.apex,
            fontSize: '17px',
            color: '#FFFFFF',
            textAlign: 'justify',
            lineHeight: 1.6,
            [theme.breakpoints.down('sm')]: {
                fontSize: '14px',
            }
        }
    };
});

export default useFormStyles;